import { USER_ENGAGEMENT_ROLES, USER_ENGAGEMENT_SOURCES } from '@/constants';
import {
  HRMUserEngagementTimeSheetDTO,
  SelectionOptions,
  UserDTO,
  UserEngagementDTO,
  UserEngagementRequestDTO
} from '@/models';

export const buildUserEngagement = (): UserEngagementDTO => {
  return {
    user: { id: -1 } as UserDTO,
    userEngagementRole: '',
    contribution: 0,
    adjustedDrops: 0,
    givingDrops: 0,
    reasonForAdjustment: '',
    peerEvaluationStatus: '',
    contributionDrops: 0,
    individualDrops: 0,
    key: 0,
    note: '',
    source: USER_ENGAGEMENT_SOURCES.MANUALLY_INPUT
  };
};

export const buildUserEngagementAction = (userEngagements: UserEngagementDTO[]): UserEngagementRequestDTO[] => {
  return userEngagements.map(userEngagement => ({
    userId: userEngagement.user.id,
    userEngagementRole: userEngagement.userEngagementRole,
    contribution: userEngagement.contribution,
    adjustedDrops: userEngagement.adjustedDrops,
    givingDrops: userEngagement.givingDrops,
    reasonForAdjustment: userEngagement.reasonForAdjustment,
    peerEvaluationStatus: userEngagement.peerEvaluationStatus,
    contributionDrops: userEngagement.contributionDrops,
    individualDrops: userEngagement.individualDrops,
    key: userEngagement.key,
    note: userEngagement.note,
    source: userEngagement.source,
    hrmTimeSheets: userEngagement.hrmTimeSheets,
    manuallyInput: userEngagement.manuallyInput
  }));
};

export const userEngagementRoleMapping = {
  [USER_ENGAGEMENT_ROLES.PROJECT_MANAGER]: 'PM',
  [USER_ENGAGEMENT_ROLES.PROJECT_MEMBER]: 'Member'
};

export const buildUserEngagementRoleOptions = (): SelectionOptions => [
  {
    text: userEngagementRoleMapping[USER_ENGAGEMENT_ROLES.PROJECT_MANAGER],
    value: USER_ENGAGEMENT_ROLES.PROJECT_MANAGER
  },
  {
    text: userEngagementRoleMapping[USER_ENGAGEMENT_ROLES.PROJECT_MEMBER],
    value: USER_ENGAGEMENT_ROLES.PROJECT_MEMBER
  }
];

export const buildUserEngagementFromHRMTimeSheet = (
  { user, userEngagementRole, source }: HRMUserEngagementTimeSheetDTO,
  contribution: number
): UserEngagementDTO => {
  return {
    user,
    userEngagementRole,
    contribution,
    adjustedDrops: 0,
    givingDrops: 0,
    reasonForAdjustment: '',
    peerEvaluationStatus: '',
    contributionDrops: 0,
    individualDrops: 0,
    key: 0,
    note: '',
    source
  };
};
